export { default } from './CourseInformation';
export type { Props, Props as CourseInformationSupportBlockProps } from './CourseInformation';
